import { ProductAdsComponent } from '@/scopes/product-ads/components/ProductAds'
import { ProductAdsList } from '@/scopes/product-ads/components/ProductAdsList'
import { useProductAds, useProductAdsListViewed } from '@/scopes/product-ads/domain/hooks'
import { tk } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { useRef } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  padding: ${tk('spacing_lg')} ${tk('spacing_md')};
  display: flex;
  flex-direction: column;
  margin-bottom: ${tk('spacing_3xl')};

  @media ${tk('mq_desktop_sm')} {
    padding: ${tk('spacing_3xl')};
  }
`

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${tk('theme_color_neutral_300')};
  border-radius: ${tk('radius_extra_large')};
  z-index: -1;

  @media ${tk('mq_desktop_sm')} {
    width: 65%;
  }
`

interface ProductAdsProps {
  contextItemId: string
  headerTitle: string | null
  infoLabel: string | null
  infoContent: string | null
  className?: string
}

export function HomeTileProductAds({ infoLabel, infoContent, contextItemId, headerTitle, className }: ProductAdsProps) {
  const { isLoading, data } = useProductAds(contextItemId, 'LandingList')
  const productAdsRef = useRef(null)
  useProductAdsListViewed(data, 'sponsored_home', productAdsRef)

  const content = !data || data.length === 0
    ? null
    : (
        <Wrapper className={className} data-qa="product-ads">
          <Background />
          <ProductAdsComponent infoLabel={infoLabel} infoContent={infoContent} headerTitle={headerTitle}>
            <ProductAdsList data={data} isLoading={isLoading} type="sponsored_home" />
          </ProductAdsComponent>
        </Wrapper>
      )

  return (
    <div ref={productAdsRef}>
      {content}
    </div>
  )
}
